import { Trash2 } from "lucide-react";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import uploadApi from "../../api/uploadApi";
import { toast } from "react-toastify";
import accountApi from "../../api/accountApi";
import { FaPaperclip, FaUpload } from "react-icons/fa";
import { Spinner } from "reactstrap";
import { confirmSubmit } from "../../utils/confirmSubmit";
import { compressFile } from "../../utils/imageCompression";

const DocumentsTab = ({ selectedClientData,onRefreshAccounts }) => {
  const token = useSelector((s) => s.auth.access_token);
  const accountId = selectedClientData?.id;
  const [loading, setLoading] = useState(false);
const attachments = selectedClientData?.attachments ;

  // const handleFileUpload = async (e) => {
  //   const files = Array.from(e.target.files);
  //   if (!files.length) return;

  //   for (const file of files) {
  //      const fd = new FormData();
  //     fd.append("file", file);
  //     try {
  //       setLoading(true);
  //       // const cloudinaryRes = await uploadToCloudinary(file);
  //              const cloudinaryRes = await uploadApi.uploadAccount(accountId, 'attachments', fd, token);
  //              console.log("cloudinaryRes acc :",cloudinaryRes)
  //       const payload = {
  //         fileName: file.name,
  //         filePath: cloudinaryRes.fileUrl,
  //         contentType: file.type,
  //       };

  //       if (accountId) {
  //         await accountApi.uploadAttachment(accountId, payload, token);
  //         toast.success("Attachment uploaded successfully");
  //         onRefreshAccounts();
  //       }
  //       setLoading(false);
  //     } catch (err) {
  //       setLoading(false);
  //       console.log("doc tab error : ",err)
  //       // toast.error(`Failed to upload ${file.name}`);
  //     }
  //   }

  //   e.target.value = "";
  // };

 const handleFileUpload = async (e) => {
  const files = Array.from(e.target.files);
  if (!files.length) return;

  for (const originalFile of files) {
    setLoading(true);

    try {
      const compressedFile = await compressFile(originalFile);

      if (compressedFile.size > 1 * 1024 * 1024) {
        toast.error(
          `${compressedFile.name} is too large. Max allowed size is 1MB.`
        );
        setLoading(false);
        continue;
      }

      const fd = new FormData();
      fd.append("file", compressedFile);

      const cloudinaryRes = await uploadApi.uploadAccount(
        accountId,
        "attachments",
        fd,
        token
      );

      console.log("cloudinaryRes acc :", cloudinaryRes);

      const payload = {
        fileName: compressedFile.name,
        filePath: cloudinaryRes.fileUrl,
        contentType: compressedFile.type,
      };

      if (accountId) {
        await accountApi.uploadAttachment(accountId, payload, token);
        toast.success("Attachment uploaded successfully");
        onRefreshAccounts();
      }
    } catch (err) {
      console.log("doc tab error : ", err);
      toast.error(`Failed to upload ${originalFile.name}`);
    } finally {
      setLoading(false);
    }
  }

  e.target.value = "";
};

  const handleRemoveAttachment = async (attachmentId) => {
    const isConfirmed = await confirmSubmit({
          title: "Confirm attachment delete",
          text: "Are you sure you want to delete this attachment?",
          confirmText: "Submit",
        });
      if (!isConfirmed) return;

    try {
        await accountApi.deleteAttachment(attachmentId, token);
        toast.success("Attachment deleted successfully");
        onRefreshAccounts();
    } catch (err) {
      console.error(err);
      toast.error("Failed to delete attachment");
    }
  };
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 px-2 py-2">
    
<div className="border border-gray-200 rounded-lg p-2 mt-1">
        <div className="flex justify-between items-center mb-1">
          <div className="text-sm font-semibold text-gray-700">Attachments</div>
      
          <label className="flex items-center gap-1 cursor-pointer text-xs text-indigo-600 hover:text-indigo-800">
            <FaUpload size={12} />
            {loading ? <Spinner size={"sm"}/> : <span>Upload</span>}
            <input
              type="file"
              multiple
              className="hidden"
              onChange={handleFileUpload}
            />
          </label>
        </div>
      
        {attachments?.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
            {attachments.map((f, index) => (
              <div
                key={index}
                className="flex items-center justify-between p-2 border border-gray-100 rounded-md bg-white hover:bg-gray-100 transition"
              >
                <div className="flex items-center gap-2 min-w-0">
                  <FaPaperclip className="text-gray-400 text-xs shrink-0" />
                  <a
                    href={f.filePath}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-xs text-gray-700 truncate hover:underline"
                    title={f.fileName}
                  >
                    {f.fileName}
                  </a>
                </div>
      
                <button
                  onClick={() => handleRemoveAttachment(f.id)}
                  className="text-xs text-red-500 hover:text-red-700 shrink-0"
                >
                  <Trash2 size={14} />
                </button>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-xs text-gray-400">No attachments uploaded</p>
        )}
      </div>
    </div>
  );
};

export default DocumentsTab;
